import { useAtom, useAtomValue } from "jotai";
import {
    balanceSheetMetricsAtom,
    balanceSheetResolutionAtom,
} from "../../../metrics.state";
import { MemoTable } from "../../../components/MemoTable";
import { useCallback } from "react";
import { CellClickedEvent } from "ag-grid-enterprise";
import { MetricsType } from "../../../metrics.types";
import { PeriodSelector } from "../../../components/PeriodSelector";
import { AIMContextViewAtom } from "../../../state/context.state";
import { AIMViewType } from "../../../InvestmentMemo.types";
import {
    BSSummaryColumnAtom,
    BSSummaryDataAtom,
    isLoadingAtom,
} from "./BSSummary.state";
import { SummaryRow } from "../SummaryFinancials.types";
import { defaultColDef } from "../defaultColDef";
import clsx from "clsx";

export function BalanceSheetSummary() {
    const metrics = useAtomValue(balanceSheetMetricsAtom);
    const resolution = useAtomValue(balanceSheetResolutionAtom);
    const data = useAtomValue(BSSummaryDataAtom);
    console.log("balance sheet table", metrics, data);
    const columns = useAtomValue(BSSummaryColumnAtom);
    const [getAIMContextView, setAIMContextView] = useAtom(AIMContextViewAtom);
    const isLoading = useAtomValue(isLoadingAtom);
    const selectedCell = (getAIMContextView as any)?.selectedCell;
    const gridId = "summary-balance-sheet-grid";
    const handleClick = useCallback(
        (params: CellClickedEvent<SummaryRow>) => {
            const field = params.colDef.field;
            if (field === "label" || !params.data?.metric || !field) return;

            if (field === "popChange" && params.data.popChange) {
                setAIMContextView({
                    type: AIMViewType.DELTA_LINEAGE,
                    props: {
                        metric: params.data.metric,
                        metricLabel: params.data.label,
                        currentSlice: params.data.currentSlice,
                        previousSlice: params.data.previousSlice,
                        popChange: params.data.popChange,
                        fieldType: params.data.fieldType,
                        resolutionWindow: resolution.window || "",
                        popLabel: params.colDef.headerName,
                    },
                    selectedCell: {
                        rowId: params.node?.id ?? "",
                        colField: field,
                        gridId,
                    },
                });
                return;
            } else {
                setAIMContextView({
                    type: AIMViewType.VALUE_LINEAGE,
                    metric: params.data.metric,
                    period: field,
                    title: params.data.label,
                    isExpanded: field === "popChange" ? false : true,
                    selectedCell: {
                        rowId: params.node?.id ?? "",
                        colField: field,
                        gridId,
                    },
                });
            }
        },
        [metrics, resolution, setAIMContextView],
    );

    return (
        <div id="summary-balance-sheet" className="space-y-3">
            <div className="flex items-center justify-between">
                <h4 className="heading-m">Summary Balance Sheet</h4>
                <PeriodSelector
                    resolutionAtom={balanceSheetResolutionAtom}
                    metricsType={MetricsType.BALANCE_SHEET}
                />
            </div>
            {isLoading ? (
                <div
                    className={clsx(
                        "h-[400px] w-full animate-pulse rounded-lg bg-slate-600",
                    )}
                />
            ) : (
                <MemoTable
                    data={data}
                    columns={columns}
                    onCellClicked={handleClick}
                    defaultColDef={defaultColDef(selectedCell, gridId)}
                    gridId={
                        gridId +
                        "-" +
                        selectedCell?.rowId +
                        "-" +
                        selectedCell?.colField
                    }
                />
            )}
        </div>
    );
}
